import {Buffer} from "buffer";
import type {IPDFStyle} from "@mytour/shared";
import {Image} from "@react-pdf/renderer";

type Props = {
  pdfStyle: IPDFStyle;
  style?: any;
};

export function PDFSquareLogo({pdfStyle, style}: Props) {
  let thumbnail = pdfStyle.logoSquareThumbnail;
  const {logoContentType} = pdfStyle;
  if (thumbnail?.type === "Buffer") {
    const bufferOriginal = Buffer.from(thumbnail.data);
    thumbnail = bufferOriginal.toString("utf8");
  }
  if (!thumbnail) {
    return null;
  }
  const src = `data:${logoContentType};base64,${thumbnail}`;
  return <Image style={style} src={src} />;
}
